import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../shared/context/AuthContext';
import LoginForm from './components/LoginForm'
import './styles.css'

export default function LoginPage() {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Se ha llegado aquí desde un lanzamiento cuyo inicio de sesión automático no
  // ha prosperado. La señal viaja en el estado de navegación, no en
  // sessionStorage, para que el aviso se muestre exactamente a quien lo
  // intentó y a nadie más.
  const fromLaunch = Boolean((location.state as { fromLaunch?: boolean } | null)?.fromLaunch);

  // El lanzamiento traía una identidad verificada que no puede abrir sesión
  // aquí. Merece un aviso distinto: no es que haga falta identificarse, es que
  // hay algo que arreglar en la ficha del profesional, y quien está delante no
  // va a resolverlo reintentando.
  const identityRefused = Boolean(
    (location.state as { identityRefused?: boolean } | null)?.identityRefused,
  );

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      // If there's a pending launch, AuthContext.login() already navigates
      // to /launch — don't override that redirect.
      if (!sessionStorage.getItem('launchToken')) {
        const from = (location.state as any)?.from;
        const redirectTo = from ? `${from.pathname}${from.search || ''}` : '/reports';
        navigate(redirectTo, { replace: true });
      }
    }
  }, [isAuthenticated, isLoading, navigate, location]);

  // Mostrar loading mientras se verifica la autenticación
  if (isLoading) {
    return null; // O un spinner si prefieres
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <LoginForm fromLaunch={fromLaunch} identityRefused={identityRefused} />
      </div>
    </div>
  )
}